import React from "react"

import {FieldGlistEditableProps} from "../../../../render/glist/glist-editable"
import FieldInlineEditable from "../../../../render/inline-editable"
import {FieldViewSize} from "../../../../const"

export default function FieldCustomViewUserAccess_GListEditable(props:FieldGlistEditableProps) {
    return <FieldInlineEditable field       = {props.field}
                                model       = {props.model}
                                size        = {FieldViewSize.SMALL}
                                onChange    = {props.onChange}
                                className   = {props.className} />
}
